function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M36.5245 22.7599H3.76636L18.6604 14.9844H51.4186L36.5245 22.7599Z",
  fill: "#F7CFC2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M51.4186 14.985L36.4767 0.0184166L3.7002 0L18.6605 14.985H51.4186Z",
  fill: "#F2F2F2"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M36.5245 22.7599H3.76636L18.6604 14.9844H51.4186L36.5245 22.7599Z",
  fill: "#CCCCCC"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M36.4769 0.0184166L33.5829 2.91719C32.7163 3.78522 31.5408 4.27265 30.3151 4.27265L1.38372 4.25792C0.670334 4.25792 0.312415 3.39356 0.817424 2.88772L3.70039 0L36.4769 0.0184166Z",
  fill: "#F7CFC2"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M36.4769 0.0184166L33.5829 2.91719C32.7163 3.78522 31.5408 4.27265 30.3151 4.27265L1.38372 4.25792C0.670334 4.25792 0.312415 3.39356 0.817424 2.88772L3.70039 0L36.4769 0.0184166Z",
  fill: "#CCCCCC"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6604 14.9844V22.7599H3.76636L18.6604 14.9844Z",
  fill: "#999999"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M36.5248 22.7599V52.8452L33.5854 55.9994H35.7354C36.2551 55.9994 36.7663 55.8741 37.2259 55.6335L50.9126 48.4879C51.224 48.3258 51.4189 48.0029 51.4189 47.6518V14.9844L36.5248 22.7599Z",
  fill: "#999999"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M3.76636 22.7383H36.5245V55.0103C36.5245 55.5567 36.082 55.9999 35.5366 55.9999H4.70773C4.18802 55.9999 3.76636 55.5776 3.76636 55.057V22.7383Z",
  fill: "#F2F2F2"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M29.8357 36.4502H14.686V42.9047H29.8357C31.615 42.9047 33.0571 41.4601 33.0571 39.6769C33.0571 37.8947 31.615 36.4492 29.8357 36.4492V36.4502Z",
  fill: "#0055FF"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5169 36.4502H25.6665V42.9047H10.5169C8.73758 42.9047 7.29543 41.4601 7.29543 39.6769C7.29543 37.8947 8.73758 36.4492 10.5169 36.4492V36.4502Z",
  fill: "#0055FF"
});

function SvgPackP(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 56,
    viewBox: "0 0 52 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = React.forwardRef(SvgPackP);
export default __webpack_public_path__ + "static/media/pack-p.37e4da4e.svg";
export { ForwardRef as ReactComponent };